export enum State {
	Received = 1,
	WaitingForConsent,
	WaitingForResearcher,
	ResearchInProgress,
	ResearchCompleted,
	Delivered,
	ConsentGiven,
	ConsentWithdrawn,
	ConsentDeclined,
	Deleted
}